<!--<template>

    <div class="phone-number-container">
        <v-select v-if="isAdmin"
                  v-model="numberType"
                  :items="numberTypeOptions"
                  :label="$t('NumberType')"
                  outlined
                  dense
                  class="number-type-select"></v-select>

        <v-text-field v-model="formattedPhoneNumber"
                      :label="$t('phoneNumber')"
                      outlined
                      dense
                      :placeholder="$t('EnterphoneNumber')"
                      :rules="phoneNumberRules"
                      @input="handleInput"
                      :hint="phoneHint"
                      class="phone-number-field"></v-text-field>
    </div>

</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: '',
            },
            mobileType: {
                type: String,
                default: '',
            },
            isAdmin: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                formattedPhoneNumber: this.formatPhoneNumber(this.value),
                numberType: this.getNumberType(),
                numberTypeOptions: [{id:'MobilePhone',value:this.$t('MobilePhone')}, {id:'HomePhone',value:this.$t('HomePhone')}]
            }
        },
        computed: {
            phoneNumberRules() {
                if (!this.isAdmin) {
                    return [
                        v => !!v || this.$t('PhoneNumberRequired'),
                        v => this.validatePhoneNumber(v) || this.$t('Invalidphonenumberformat'),
                    ]
                }

                else {
                    return []
                }
            },
            phoneHint() {
                return this.mobileType === 'MobilePhone#' ? this.$t('PhoneHint') : this.$t('HomeHint')
            }
        },
        watch: {
            value(newValue) {
                this.formattedPhoneNumber = this.formatPhoneNumber(newValue)
            },
            numberType(newType) {
                this.formattedPhoneNumber = this.formatPhoneNumber(this.formattedPhoneNumber.replace(/\D/g, ''))
                this.$emit('input', `${this.numberType}#${this.formattedPhoneNumber}`)
            }
        },
        methods: {
            getNumberType() {
                if (this.mobileType === 'MobilePhone#') {

                    return this.$t('MobilePhone')
                } else {
                    return this.numberType

                }

            },

            formatPhoneNumber(phoneNumber) {
                if (!phoneNumber) return ''
                const [type, value] = phoneNumber.split('#')

                if (type && [this.$t('MobilePhone'), this.$t('HomePhone')].includes(type)) {
                    this.numberType = ''
                    this.numberType = type
                }

                phoneNumber = value

                if (this.numberType === 'MobilePhone#') {
                    return phoneNumber
                } else {
                    return phoneNumber
                }
                return phoneNumber
            },
            validatePhoneNumber(phoneNumber) {
                if (phoneNumber) {
                    const cleanedNumber = phoneNumber.replace(/\D/g, '')
                    if (this.mobileType === 'MobilePhone#') {
                        return /^05\d{8}$/.test(cleanedNumber)
                    } else {
                        return /^011\d{7}$/.test(cleanedNumber)
                    }
                }
                return false
            },
            handleInput(value) {
                const cleanedValue = value.replace(/\D/g, '')
                this.formattedPhoneNumber = this.formatPhoneNumber(`${this.numberType}#${cleanedValue}`)
                this.$emit('input', `${this.numberType}#${this.formattedPhoneNumber}`)
            }
        }
    }
</script>

<style scoped>
    .phone-number-container {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .number-type-select {
        flex: 0 1 150px;
    }

    .phone-number-field {
        flex: 1;
    }
</style>-->

<template>
    <div class="phone-number-container">
        <v-select v-if="isAdmin"
                  v-model="numberType"
                  :items="numberTypeOptions"
                  item-value="id"
                  item-text="value"
                  :label="$t('NumberType')"
                  outlined
                  dense
                  class="number-type-select"></v-select>

        <v-text-field v-if="!isAdmin" v-model="formattedPhoneNumber"
                      :label="$t('phoneNumber')"
                      outlined
                      dense
                      :placeholder="placeholderText"
                      :rules="phoneNumberRules"
                      @input="handleInput"
                      :hint="phoneHint"
                      persistent-hint
                      prefix="+966"
                      class="phone-number-field"></v-text-field>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: '',
            },
            mobileType: {
                type: String,
                default: '',
            },
            isAdmin: {
                type: Boolean,
                default: true,
            },
            validate: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                formattedPhoneNumber: this.formatPhoneNumber(this.value),
                numberType: this.getNumberType(),
                numberTypeOptions: [
                    { id: 'MobilePhone', value: this.$t('MobilePhone') },
                    { id: 'HomePhone', value: this.$t('HomePhone') }
                ]
            }
        },
        computed: {
            phoneNumberRules() {
                if (!this.isAdmin) {
                    return [
                        v => !!v || this.$t('PhoneNumberRequired') || this.validate == true,
                        v => this.validatePhoneNumber(v) || this.$t('Invalidphonenumberformat'),
                    ]
                }
                return []
            },
            placeholderText() {
                if (this.mobileType === 'MobilePhone#') {
                    return '5XXXXXXXX' // After +966 prefix
                } else {
                    return '1XXXXXXXX' // Landline after +966 prefix
                }
            },
            phoneHint() {
                if (this.mobileType === 'MobilePhone#') {
                    return this.$t('PhoneHint') || 'Mobile: 5XXXXXXXX (9 digits) or 05XXXXXXXX (10 digits)'
                } else {
                    return this.$t('HomeHint') || 'Landline: 1XXXXXXXX (9 digits) or 01XXXXXXXX (10 digits, area codes: 11-17)'
                }
            }
        },
        watch: {
            value(newValue) {
                this.formattedPhoneNumber = this.formatPhoneNumber(newValue)
            },
            numberType(newType) {
                this.formattedPhoneNumber = this.formatPhoneNumber(this.formattedPhoneNumber.replace(/\D/g, ''))
                this.$emit('input', `${this.numberType}#${this.formattedPhoneNumber}`)
            }
        },
        methods: {
            getNumberType() {
                if (this.mobileType === 'MobilePhone#') {
                    return 'MobilePhone'
                } else {
                    return this.numberType
                }
            },
            formatPhoneNumber(phoneNumber) {
                if (!phoneNumber) return ''
                const [type, value] = phoneNumber.split('#')
                if (type && ['MobilePhone', 'HomePhone'].includes(type)) {
                    this.numberType = type
                }

                phoneNumber = value
                return phoneNumber
            },
            validatePhoneNumber(phoneNumber) {
                
                if (phoneNumber) {
                    const cleanedNumber = phoneNumber.replace(/\D/g, '')
                    
                    if (this.mobileType === 'MobilePhone#') {
                        // KSA Mobile validation
                        // Accepts: 5XXXXXXXX (9 digits - after +966), 05XXXXXXXX (10 digits), or 9665XXXXXXXX (12 digits)
                        // Mobile numbers start with 5 (after country code), 05 (local), or 9665 (international)
                        
                        if (/^5\d{8}$/.test(cleanedNumber)) {
                            return true // Format after +966 prefix: 5XXXXXXXX
                        }
                        if (/^05\d{8}$/.test(cleanedNumber)) {
                            return true // Local format: 05XXXXXXXX
                        }
                        if (/^9665\d{8}$/.test(cleanedNumber)) {
                            return true // International without +: 9665XXXXXXXX
                        }
                        return false
                    } else {
                        // KSA Landline validation
                        // Accepts: 1[1-7]XXXXXXX (9 digits - after +966), 01[1-7]XXXXXXX (10 digits), or 96601[1-7]XXXXXXX (13 digits)
                        // Valid area codes: 011, 012, 013, 014, 016, 017
                        
                        if (/^1[1-7]\d{7}$/.test(cleanedNumber)) {
                            return true // Format after +966 prefix: 1XXXXXXXX
                        }
                        if (/^01[1-7]\d{7}$/.test(cleanedNumber)) {
                            return true // Local format: 01XXXXXXXXX
                        }
                        if (/^96601[1-7]\d{7}$/.test(cleanedNumber)) {
                            return true // International without +: 96601XXXXXXXXX
                        }
                        return false
                    }
                }
                return false
            },
            handleInput(value) {
                const cleanedValue = value.replace(/\D/g, '')
                
                this.formattedPhoneNumber = this.formatPhoneNumber(`${this.numberType}#${cleanedValue}`)
                this.$emit('input', `${this.numberType}#${this.formattedPhoneNumber}`)
            }
        }
    }
</script>

<style scoped>
    .phone-number-container {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .number-type-select {
        flex: 0 1 150px;
    }

    .phone-number-field {
        flex: 1;
    }
</style>

